import { render, staticRenderFns } from "./BodyFeedback.vue?vue&type=template&id=13cc1bc0&scoped=true&"
import script from "./BodyFeedback.vue?vue&type=script&lang=js&"
export * from "./BodyFeedback.vue?vue&type=script&lang=js&"
import style0 from "./BodyFeedback.vue?vue&type=style&index=0&id=13cc1bc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cc1bc0",
  null
  
)

component.options.__file = "BodyFeedback.vue"
export default component.exports